<template>
	<div class="about">
		<div class="pg-header">
			<div><label class="title">{{ tagName }}
					{{ {
						1: '待随访',
						2: '已随访',
						3: '暂存',
						4: '终止随访',
					}[menuStatus]
					}}
				</label></div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>{{ tagName }}随访管理</span>|
					<span>{{ {
						1: '待随访',
						2: '已随访',
						3: '暂存',
						4: '终止随访',
					}[menuStatus]
					}}</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter.name"
								@keyup.enter.native="handleFilter(0, $event)"></el-input></label>
						<label>住院号<el-input size="small" maxlength="18" style="width:80px"
								v-model.trim="filter.admissionNumber"
								@keyup.enter.native="handleFilter(1, $event)"></el-input></label>
						<label>身份证号<el-input size="small" maxlength="18" style="width:150px"
								v-model.trim="filter.cardNum" @keyup.enter.native="handleFilter(1, $event)"></el-input>
						</label>

						<label v-if="menuStatus == 3">随访类型
							<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.followupType"
								@change="handleFilter(5, $event)">
								<el-option
									v-for="item in [{ id: 1, name: '电话' }, { id: 2, name: '短信' }, { id: 4, name: '小程序' }]"
									:key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</label>
						<div style="display: inline-block;">来源
							<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.datasources"
								@change="handleFilter(4, $event)">
								<el-option label="出院" :value="Number(2)"></el-option>
								<el-option label="门诊" :value="Number(1)"></el-option>
							</el-select>
						</div>
						<label v-if="filter.datasources">{{
							filter.datasources ? { 1: '就诊', 2: '出院' }[filter.datasources] : ''
						}}日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.outdate"
								:picker-options="pickerOptions" @change="handleFilter(3, $event)"></el-date-picker>
						</label>
						<!-- <label>联系电话<el-input size="small" maxlength="18" style="width:150px" v-model.trim="filter.phone" @keyup.enter.native="handleFilter(1, $event)"></el-input></label> -->
					</div>
					<div class="def-key">

						<label>应随访日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']"
								style="width:220px;margin-right: 8px;" type="daterange" align="right" unlink-panels
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
								v-model="filter.date" :picker-options="pickerOptions"
								@change="handleFilter(2, $event)"></el-date-picker>
						</label>
						<label v-if="menuStatus != 1">{{ menuStatus == 2 ? '实际随访日期' : '操作时间' }}
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.updateDate"
								:picker-options="pickerOptions" @change="handleFilter(6, $event)"></el-date-picker>
						</label>
						<div style="margin-right:10px;">科室
							<el-select size="small" filterable clearable placeholder="请选择" multiple collapse-tags
								v-model="filter.selectedDepartmentIdList" @change="handleFilter(5, $event)"
								class="multiple-select">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<label>诊断
							<el-input size="small" style="width:80px" v-model.trim="filter.outHospitalDiagnosisName"
								@keyup.enter.native="handleFilter(4, $event)"></el-input>
						</label>
						<label v-if="menuStatus == 3 && filter.followupType == 4">发送状态
							<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.pushStatus"
								@change="handleFilter(5, $event)">
								<el-option
									v-for="item in [{ id: 0, name: '未发送' }, { id: 1, name: '已发送' }, { id: 2, name: '已填写' }]"
									:key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</label>
						<div style='display: flex;align-items: center;'>
							<el-checkbox v-model="filter.showMyself" @change="handleFilter(5, $event)">本人患者</el-checkbox>
						</div>

					</div>
					<div class="def-key" style="align-items: end;">
						<div style="display: inline-block;">随访次数
							<el-select size="small" filterable clearable placeholder="请选择"
								v-model="filter.currentFollowupNum" @change="handleFilter(4, $event)">
								<el-option v-for="num in followupNumbers" :key="num" :label="num"
									:value="num"></el-option>
							</el-select>
						</div>
						<label v-if="menuStatus == 1">年龄
							<el-input size="small" style="width:80px" v-model.trim="filter.age"
								@keyup.enter.native="handleFilter(4, $event)"></el-input>
						</label>
						<div style="display: inline-block;">小程序绑定
							<el-select size="small" filterable clearable placeholder="请选择"
								v-model="filter.bindingStatus" @change="handleFilter(4, $event)">
								<el-option label="未绑定" :value="0"></el-option>
								<el-option label="已绑定" :value="1"></el-option>
							</el-select>
						</div>
						<template v-if="menuStatus != 1 && menuStatus != 4">
							<div style="display: inline-block;">有效随访
								<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.valid"
									@change="handleFilter(4, $event)" value-key="value">
									<el-option label="有效" :value="1"></el-option>
									<el-option label="无效" :value="0"></el-option>
								</el-select>
							</div>
							<div style="display: inline-block;" v-if="filter.valid === 0">无效原因
								<el-select size="small" filterable clearable placeholder="请选择"
									v-model="filter.notValidReason" @change="handleFilter(4, $event)">
									<el-option v-for="option in notValidReasons" :key="option.value"
										:label="option.label" :value="option.value"></el-option>
								</el-select>
							</div>
							<div style="display: inline-block;">患者问题
								<el-select size="small" filterable clearable placeholder="请选择"
									v-model="filter.hasQuestionContent" @change="handleFilter(4, $event)">
									<el-option label="有" :value="1"></el-option>
									<el-option label="无" :value="0"></el-option>
								</el-select>
							</div>
							<div style="display: inline-block;">随访备注
								<el-select size="small" filterable clearable placeholder="请选择"
									v-model="filter.hasRemark" @change="handleFilter(4, $event)">
									<el-option label="有" :value="1"></el-option>
									<el-option label="无" :value="0"></el-option>
								</el-select>
							</div>

						</template>

						<div style="align-content: center;display: flex; max-height: 32px;  text-align: right;">
							<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
							<el-button class="btn-export" size="mini" round @click="exportReport"
								style="margin-right: 10px;"><i class="icon-export"></i>导出</el-button>
						</div>
					</div>

				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" :key="menuStatus" header-cell-class-name="tab-cell"
					cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading"
					@selection-change="selectionChange" v-if="menuStatus">
					<el-table-column prop="name" label="姓名" width="120" fixed="left">
						<template slot-scope="scope">
							<router-link class="noline" target="_blank"
								:to="{ name: 'Patient/User', query: { patientId: scope.row.patientId, t: 5, date: scope.row.date,datasources:scope.row.datasources, followupId: scope.row.id }}">
								<span class="fc key">
									<i class="icon-fav small" v-if="scope.row.star == 1"></i>
									{{ scope.row.name }}
									<svg-icon iconName="icon-a-zu1595" v-if="scope.row.bindingStatus==1" style="width:15.28px;height:15px"></svg-icon>
								</span>
							</router-link>
						</template>
					</el-table-column>
					<el-table-column prop="departmentName" label="科室" show-overflow-tooltip></el-table-column>
					<el-table-column prop="admissionNumber" label="住院号" width="140"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="phone" label="联系电话" width="120" show-overflow-tooltip></el-table-column>
					<!-- 0822 隐藏begin -->
					<!-- <el-table-column prop="cardNum" label="身份证号" width="140"></el-table-column> -->
					<!-- <el-table-column label="性别" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.sex == 1">男</span>
							<span v-else>女</span>
						</template>
					</el-table-column> -->

					<!-- 0822 隐藏end -->
					<el-table-column prop="age" label="年龄" width="80" v-if="menuStatus == 1">
						<template slot-scope="scope">
							<span>{{ scope.row.age }}岁</span>
						</template>
					</el-table-column>
					<el-table-column prop="outHospitalDiagnosisName" label="诊断" show-overflow-tooltip></el-table-column>
					<el-table-column prop="docName" label="责任医师" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="" label="来源" width="80" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.datasources == 0">院中</span>
							<span v-if="scope.row.datasources == 1">门诊</span>
							<span v-if="scope.row.datasources == 2">出院</span>
						</template>
					</el-table-column>
					<el-table-column prop="outTimeDate" :label="filter.datasources == 1 ? '就诊时间' : '出院时间'" width="120"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="followupNum" width="120" label="随访次数"></el-table-column>
					<el-table-column prop="date" label="应随访日期" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="date2" label="实际随访日期" width="120" show-overflow-tooltip
						v-if="menuStatus == 2"></el-table-column>
					<el-table-column prop="updateTime" label="操作时间" width="120" show-overflow-tooltip
						v-if="menuStatus == 3 || menuStatus == 4"></el-table-column>
					<el-table-column prop="stopReasonStr" label="终止原因" width="100" show-overflow-tooltip
						v-if="menuStatus == 4"></el-table-column>
					<template v-if="menuStatus !== 1 && menuStatus !== 4">
						<el-table-column prop="validReasonStr" label="有效随访" width="100"
							show-overflow-tooltip></el-table-column>
						<el-table-column label="发送状态" width="120">
							<template slot-scope="scope">
								<span v-if="scope.row.pushStatus == 1">已发送</span>
								<span v-if="scope.row.pushStatus == 0">未发送</span>
								<span v-if="scope.row.pushStatus == 2">已填写</span>
							</template>
						</el-table-column>
						<el-table-column prop="questionContent" label="患者问题" width="100"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="questionSolution" label="解决与处理" width="100"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="remark" label="备注" width="100" show-overflow-tooltip></el-table-column>
					</template>
					<el-table-column prop="reviserName" label="排期人" width="120" v-if="menuStatus == 1"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="reviserName" label="操作人" width="120" v-if="menuStatus != 1"
						show-overflow-tooltip></el-table-column>
					<el-table-column fixed="right" label="操作" width="160">
						<template slot-scope="scope">
							<div class="tab-action">
								<template v-if="menuStatus == 1 || menuStatus == 3">
									<el-tooltip content="随访" placement="top" :enterable="false"><router-link
											class="noline" target="_blank"
											:to="{ name: 'Patient/User', query: { patientId: scope.row.patientId, t: 5, date: scope.row.date, followupId: scope.row.id } }"><i
												class="icon-follow"></i></router-link></el-tooltip>

									<el-tooltip content="终止随访" placement="top" :enterable="false"><i class="icon-wufan"
											@click="showDlg(1, scope.row)"></i></el-tooltip>
								</template>
								<template v-else>
									<el-tooltip content="查看" placement="top" :enterable="false">
										<router-link class="noline" target="_blank"
											:to="{ name: 'Patient/User', query: { patientId: scope.row.patientId, t: 5, date: scope.row.date,datasources:scope.row.datasources,followupId: scope.row.id } }">
											<i class="icon-research"></i>
										</router-link>
									</el-tooltip>
									<el-popconfirm confirmButtonText='确定'
										:title="menuStatus == 2 ? '确定回退到暂存吗？' : '确定回退到待随访吗？'" @confirm="saveForm(scope.row)"
										v-if="permission">
										<el-tooltip content="回退" slot="reference" placement="top" :enterable="false"><i
												class="icon-sync"></i></el-tooltip>
									</el-popconfirm>
								</template>
							</div>
						</template>
					</el-table-column>
					<template v-if="menuStatus == 1&&(filter.bindingStatus!==0&&filter.bindingStatus!==1)" #empty>
						<div style="text-align: center; padding: 20px;">
							<el-icon>
								<Warning />
							</el-icon>
							<p>未查询到数据 <span @click="goToPatient" class="toPatient">【查看原因】</span> </p>
						</div>
					</template>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>
		<el-dialog title="终止随访" width="560px" :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form1">
				<el-form-item label="终止随访类型" prop="stopType">
					<el-radio-group v-model="form1.stopType">
						<el-radio :label="1">单次终止</el-radio>
						<el-radio :label="2">全部终止</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="终止随访原因" prop="stopReason">
					<el-radio-group v-model="form1.stopReason">
						<el-radio label="患者已住院">患者已住院</el-radio>
						<el-radio label="患者死亡">患者死亡</el-radio>
						<el-radio label="无法联系到患者">无法联系到患者</el-radio>
						<el-radio label="other">其他原因</el-radio>
						<el-input size="mini" placeholder="输入其他原因" style="width: 250px;" v-model="form1.otherReason"
							v-if="form1.stopReason == 'other'"></el-input>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm1">保 存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
	mixins: [mixin],
	data() {
		return {
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				cardNum: '',
				expectFollowupDateStart: '',
				expectFollowupDateEnd: '',
				hospitalDepartmentIds: '',
				selectedDepartmentIdList: [],
				outHospitalDiagnosisName: '',
				followupState: '2',
				date: [],
				pageNumber: 1,
				pageSize: 10,
				updateDateStart: '',
				updateDateEnd: '',
				updateDate: [],
				valid: '',
				notValidReason: '',
				hasRemark: '',
				hasQuestionContent: '',
				tagId: '',
				datasources: null,
				showMyself: false,
				bindingStatus:null
			},
			deptList: [],
			tagName: '',
			form: {
				followupId: 0
			},
			menuStatus: null,
			followupNumbers: Array.from({ length: 10 }, (_, i) => i + 1),
			notValidReasons: [
				{ label: '未接', value: 1 },
				{ label: '关机', value: 2 },
				{ label: '电话不通', value: 3 },
				{ label: '长时间超过10次无人接听', value: 4 },
				{ label: '停机', value: 5 },
				{ label: '空号', value: 6 },
				{ label: '错号', value: 7 },
				{ label: '拒接', value: 8 },
				{ label: '修改号', value: 9 },
				{ label: '其他', value: 10 },
			],
			dlg: {
				active: false,
				rules: {
					stopType: { required: true, message: '请选择' },
					stopReason: { required: true, message: '请选择' },
				}
			},
			form1: { id: 0, stopType: '', stopReason: '', otherReason: '' },

		}
	},
	watch: {
		// 优化后的路由监听
		'$route.query': {
			handler(newQuery, oldQuery) {
				// 避免初始化时重复调用
				if (!oldQuery) return;

				// 只有关键参数变化时才重新加载
				const keyParams = ['status', 'datasources', 'tagId', 'depId', 'valid', 'date', 'date2', 'state'];
				const hasKeyChange = keyParams.some(key => {
					// 对数组类型的参数进行特殊处理
					if (Array.isArray(newQuery[key]) || Array.isArray(oldQuery[key])) {
						return JSON.stringify(newQuery[key]) !== JSON.stringify(oldQuery[key]);
					}
					return newQuery[key] !== oldQuery[key];
				});

				if (hasKeyChange) {
					this.initializeFromQuery(newQuery);
					this.loadList();
				}
			},
			immediate: false // 不立即执行，避免初始化时重复调用
		}
	},

	created() {
		// 初始化数据
		this.initializeFromQuery(this.$route.query);

		// 加载基础数据
		this.loadInitialData();
	},
	mounted() {
		// 监听页面显示隐藏
		document.addEventListener('visibilitychange', this.handleVisiable);
		// let callState=localStorage.getItem('callState');
		// if(callState){
		// 	localStorage.removeItem('callState');
		// }
		// 权限控制
		this.user = JSON.parse(localStorage.getItem('user')).data;
		this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1" || this.user.user.roleId == "7" || this.user.user.roleId == "9") ? true : false;
	},
	destroyed() {
		document.removeEventListener('visibilitychange', this.handleVisiable)
	},
	methods: {
		// 从查询参数初始化数据
		initializeFromQuery(query) {
			// 更新基础参数
			this.filter.datasources = query.datasources ? Number(query.datasources) : null;

			// 设置菜单状态
			if (query.status) {
				this.$set(this, 'menuStatus', Number(query.status));
				this.filter.followupState = query.status;
			}

			// 处理日期参数
			this.handleDateParams(query);

			// 处理其他参数
			this.handleOtherParams(query);

			// 重置分页
			this.filter.pageNumber = 1;
		},

		// 处理日期参数
		handleDateParams(query) {
			// 处理 date 参数（应随访日期或操作时间）
			if (query.date) {
				if (typeof query.date === 'string') {
					this.filter.updateDateStart = dayjs(query.date).format('YYYY-MM-DD 00:00:00');
					this.filter.updateDateEnd = dayjs(query.date).format('YYYY-MM-DD 23:59:59');
					this.filter.updateDate = [this.filter.updateDateStart, this.filter.updateDateEnd];
				} else if (Array.isArray(query.date)) {
					this.filter.expectFollowupDateStart = dayjs(query.date[0]).format('YYYY-MM-DD 00:00:00');
					this.filter.expectFollowupDateEnd = dayjs(query.date[1]).format('YYYY-MM-DD 23:59:59');
					this.filter.date = [this.filter.expectFollowupDateStart, this.filter.expectFollowupDateEnd];
				}
			}

			// 处理 date2 参数（出院/就诊日期）
			if (query.date2 && Array.isArray(query.date2)) {
				this.filter.outHospitalTimeStart = dayjs(query.date2[0]).format('YYYY-MM-DD 00:00:00');
				this.filter.outHospitalTimeEnd = dayjs(query.date2[1]).format('YYYY-MM-DD 23:59:59');
				this.filter.outdate = [this.filter.outHospitalTimeStart, this.filter.outHospitalTimeEnd];
			}
		},

		// 处理其他参数
		handleOtherParams(query) {
			// 处理状态参数
			if (query.state) {
				this.filter.followupState = query.state.toString();
			}

			// 处理标签和科室参数
			this.filter.tagId = query.tagId || '';
			this.filter.selectedDepartmentIdList = query.depId ? [Number(query.depId)] : [];
			this.filter.valid = query.valid ? parseInt(query.valid) : '';

			// 重置其他搜索条件
			this.resetSearchFields();
		},

		// 重置搜索字段
		resetSearchFields() {
			this.filter.name = '';
			this.filter.cardNum = '';
			this.filter.outHospitalDiagnosisName = '';
			this.filter.notValidReason = '';
			this.filter.hasRemark = '';
			this.filter.hasQuestionContent = '';
			this.filter.showMyself = false;
			this.filter.bindingStatus=null;
		},

		// 加载初始数据
		async loadInitialData() {
			try {
				// 加载科室下拉数据
				const res = await api.getDeptDropdown({});
				if (res.code === 1000 && res.data) {
					this.deptList = res.data;
				}

				// 加载列表数据
				this.loadList();

			} catch (error) {
				console.error('加载初始数据失败:', error);
				this.$message.error('加载初始数据失败');
			}
		},

		async loadList() {
			this.isLoading = true;
			if (this.filter.selectedDepartmentIdList) {
				this.filter.hospitalDepartmentIds = this.filter.selectedDepartmentIdList.join(',');
			}
			let res = await api.getFollowList(this.filter);
			if (res.code == 500) {
				return this.$router.push({
					name: 'Login',
					query: {
						r: location.href
					}
				});
			}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item) => {
					item.date = item.expectFollowupDate ? dayjs(item.expectFollowupDate).format('YYYY-MM-DD') : "";
					item.date2 = item.followupDate ? dayjs(item.followupDate).format('YYYY-MM-DD HH:mm:ss') : '';
					item.cardNum = utils.hideIdCard(item.cardNum);
					item.phone = utils.hidePhone(item.phone);
				})
				this.list.data = res.data;
			}
			// 0530 新增
			if (this.filter.tagId != '') {
				let res2 = await api.getTag(this.filter.tagId);
				if (res2.code == 1000 && res2.data) {
					this.tagName = res2.data.name;
				}
			}
			this.isLoading = false;
		},
		// 回退
		async saveForm(item) {
			let res;
			this.form.followupId = item.id;
			if (item.followupState == 2) {
				this.form.followupState = 3;
			} else if (item.followupState == 4) {
				this.form.followupState = 1;
			}
			this.isLoading = true;
			res = await api.rollbackFollowState(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.loadList();
		},
		handleTab() {
			// 切换列表类型
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			switch (key) {
				case 2:
					if (this.filter.date) {
						this.filter.expectFollowupDateStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.expectFollowupDateEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.expectFollowupDateStart = '';
						this.filter.expectFollowupDateEnd = '';
					}
					break;
				case 3:
					if (this.filter.outdate) {
						this.filter.outHospitalTimeStart = dayjs(this.filter.outdate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.outHospitalTimeEnd = dayjs(this.filter.outdate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.outHospitalTimeStart = '';
						this.filter.outHospitalTimeEnd = '';
					}
					break;
				case 5:
					if (this.filter.selectedDepartmentIdList) {
						this.filter.hospitalDepartmentIds = this.filter.selectedDepartmentIdList.join(',');
					} else {
						this.filter.updateDateStart = '';
						this.filter.updateDateEnd = '';
					}
					break;
				case 6:
					if (this.filter.updateDate) {
						this.filter.updateDateStart = dayjs(this.filter.updateDate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.updateDateEnd = dayjs(this.filter.updateDate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.updateDateStart = '';
						this.filter.updateDateEnd = '';
					}
					break;
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		exportReport() {
			this.filter.pageSize = this.list.total;
			let url = api.exportFollowup2ByObject(this.filter);
			const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);
			this.filter.pageSize = 10;

		},
		handleVisiable(e) {
			// 关闭新开页面，回到列表页，刷新列表数据
			if (e.target.visibilityState == "visible") {
				this.loadList()
			}
		},
		showDlg(v, item) {
			this.dlg.active = true;
			this.$nextTick(() => {
				this.$refs['form'].resetFields();
				this.form1.id = item.id;
			});
		},
		// 终止随访
		async saveForm1() {
			this.$refs['form'].validate(async (valid) => {
				if (valid) {
					let form = JSON.parse(JSON.stringify(this.form1));
					if (form.stopReason == 'other') { form.stopReason = form.otherReason; }
					if (form.stopReason == '') { return this.$message.warning('请输入终止原因') }
					this.isLoading = true;
					let res = await api.stopFollow(form);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功');
					this.closeDlg();
					this.loadList();
				}
			})
		},
		closeDlg() {
			this.dlg.active = false;
		},
		goToPatient() {
			if (this.menuStatus !== 1) return;
			const { admissionNumber, name, cardNum } = this.filter;
			const query = { dataType: 4, datasources: this.filter.datasources, ...(admissionNumber && { admissionNumber }), ...(name && !admissionNumber && { name }), ...(cardNum && !admissionNumber && !name && { cardNum }) };

			this.$router.push({ name: 'Common/FindPatient', query });
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

.search-bar {
	.multiple-select {
		/deep/ .el-input {
			width: 250px;
			margin: 0;
		}
	}
}
</style>